(function() {
    $(document).ready(function() {
        const articles = $('.mod24Flat article');
        if (articles.length > 0) {
            $(document).on('scroll', function() {
                articles.each(function() {
                    const $this = $(this);
                    const scrollBottom = $(window).scrollTop() + $(window).height();
                    if (!$this.hasClass('.zoom')) {
                        if ($this.offset().top + ($this.height() / 2) <= scrollBottom) {
                            $this.addClass('zoom');
                        }
                    }
                });
            });
        }
    });
})();
